export const COMMENTS_APIS_CREATE_COMMENTS_FALSY_PAYLOAD = 'COMMENTS_APIS_CREATE_COMMENTS_FALSY_PAYLOAD';
export const COMMENTS_APIS_CREATE_COMMENTS_BAD_SERVER_STATUS = 'COMMENTS_APIS_CREATE_COMMENTS_BAD_SERVER_STATUS';
export const COMMENTS_APIS_CREATE_COMMENTS_UNEXPECTED = 'COMMENTS_APIS_CREATE_COMMENTS_UNEXPECTED';

export const COMMENTS_ACTIONS_CREATE_COMMENTS_UNEXPECTED = 'COMMENTS_ACTIONS_CREATE_COMMENTS_UNEXPECTED';
